import Layout from "layouts";
import React from "react";
import { useParams } from "react-router-dom";
import OrderDetailComponent from "./OrderDetailComponent";

export default function SubscriptionDetails() {
  const { slotId = "" } = useParams();
  return (
    <Layout
      breadCrumb={[
        { label: "One-off-orders", to: "/one_off_orders" },
        { label: `One-off-order#${slotId}`, to: "#" },
      ]}
    >
      <OrderDetailComponent orderId={slotId} />
    </Layout>
  );
}
